/* eslint-disable i18next/no-literal-string */
import type { AssetMedia } from '@aikoa/common'

export const defaultImageUploadAccept = ['image/*']

export function generateFileName(originalName?: string): string {
  const timestamp = Date.now()
  const random = Math.random().toString(36).slice(7)
  const extension = originalName?.split('.').pop() || 'jpg'
  return `upload_${timestamp}_${random}.${extension}`
}

export function getFileType(mimeType?: string): AssetMedia['type'] {
  if (!mimeType) return 'image'
  if (mimeType.startsWith('image/')) return 'image'
  if (mimeType.startsWith('video/')) return 'video'
  return 'document'
}

export function validateFileType(mimeType: string | undefined | null, accept: string[]): boolean {
  if (!mimeType) return accept.includes('*/*')

  return accept.some((type) => {
    if (type === '*/*') return true
    if (type.endsWith('/*')) {
      const prefix = type.slice(0, -2)
      return mimeType.startsWith(prefix)
    }
    return mimeType === type
  })
}

export function validateFileSize(size: number | undefined, maxSizeBytes: number): boolean {
  return !size || size <= maxSizeBytes
}

export function formatFileSize(bytes: number): string {
  return `${Math.round(bytes / 1024 / 1024)}MB`
}

export function formatAcceptedFileType(acceptedType: string): string {
  if (acceptedType.endsWith('/*')) {
    return acceptedType
  }

  const acceptedSubtype = acceptedType.split('/')[1]

  if (!acceptedSubtype) {
    return acceptedType
  }

  return acceptedSubtype
}

export function getErrorMessage(error: string, maxSizeMB: number): string {
  const messages: Record<string, string> = {
    'Invalid URL format': 'Virheellinen verkko-osoite',
    'Invalid URL protocol': 'Vain http- ja https-osoitteet ovat tuettuja',
    'File type not supported': 'Tiedostotyyppi ei ole tuettu',
    'File too large': `Tiedosto on liian suuri. Enimmäiskoko on ${maxSizeMB}MB`,
    'Payload too large': `Tiedosto on liian suuri. Enimmäiskoko on ${maxSizeMB}MB`,
    'Network error': 'Verkkovirhe. Tarkista yhteytesi ja yritä uudelleen',
    'Permission denied': 'Käyttöoikeus evätty. Anna tarvittavat käyttöoikeudet asetuksista',
    'Storage error': 'Tallennusvirhe. Yritä myöhemmin uudelleen',
  }

  return messages[error] || error || 'Tapahtui odottamaton virhe. Yritä uudelleen'
}
